// extracted by mini-css-extract-plugin
module.exports = {"switchContainer":"styles_switchContainer__Y5R6d","closeButton":"styles_closeButton__1M0DF","backButton":"styles_backButton__24u2Q"};